(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui/lib/theme-chalk/index.css"), require("element-ui"), require("moment"), require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("PlatformUI", ["element-ui/lib/theme-chalk/index.css", "element-ui", "moment", "axios"], factory);
	else if(typeof exports === 'object')
		exports["PlatformUI"] = factory(require("element-ui/lib/theme-chalk/index.css"), require("element-ui"), require("moment"), require("axios"));
	else
		root["PlatformUI"] = factory(root["element-ui/lib/theme-chalk/index.css"], root["ElementUI"], root["moment"], root["axios"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_44__, __WEBPACK_EXTERNAL_MODULE_45__, __WEBPACK_EXTERNAL_MODULE_99__, __WEBPACK_EXTERNAL_MODULE_85__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition